<template>
  <section>
    <div class="pdt-24 shadow-bottom" v-if="nextLessonData">
      <div class="d-flex mgl-8 mgr-8">
        <div class="w-40 mgl-8 mgr-8">
          <!-- <img src="@/images/icon/banner_alarm.png" alt=""> -->
          <i class="material-icons orange600 mb-36">notification_important</i>
        </div>
        <div class="t-body2 mgl-8 mgr-8">
          {{ $t("143", { str: nextLessonName }) }}
          <!-- 소셜 미디어 플랫폼 분석하기 강의를 학습할 차례입니다. -->
        </div>
      </div>
      <div class="mgt-5 pdb-17 mgl-16 mgr-16 d-flex flex-row-reverse">
        <span class="t-body3 t-color-red1" @click="learnLesson(nextLessonData)">
          {{ $t("144") }}
          <!-- 학습하기 -->
        </span>
      </div>
    </div>

    <div class="pda-default">
      <no-data v-if="!lessonsList.length && dataLoadState"></no-data>
      <div class="mdc-card mdc-elevation--z3" v-if="lessonsList.length">
        <div class="t-subtitle2 mgt-16 mgb-16 mgl-16 mgr-16">
          {{ $t("145") }}
          <!-- 강의 -->
        </div>

        <div
          v-for="(lesson, index) in lessonsList"
          :key="index"
          class="ripple-item lesson-item"
        >
          <div
            class="d-flex flex-row justify-content-between pdt-12 pdb-16 mgl-8 mgr-8"
          >
            <div class="pdl-8 pdr-8">
              <img
                src="@/images/icon/exam_icon.png"
                v-if="lesson.contentsType.value === 'EXAM_PAPER'"
                class="profile"
              />
              <img
                src="@/images/icon/contents_icon.png"
                v-else
                class="profile"
              />
              <div class="progress mgt-6">
                <div class="progress-body">
                  <div
                    class="progress-sub"
                    :style="`width:${lesson.rate}%;`"
                  ></div>
                </div>
                <div class="t-helper progress-text">
                  {{ parseInt(lesson.rate) }}%
                </div>
              </div>
            </div>
            <div class="pdl-8 pdr-8 flex-grow-1" @click="learnLesson(lesson)">
              <div class="t-body1">
                {{ lesson.name }}
                <div class="t-body3 t-color-gray2">
                  <span>{{ $t(lesson.contentsType.translate) }} :</span>
                  <span v-if="lesson.status.value === 'WAITING'">
                    <!-- 학습대기 -->
                  </span>
                  <span v-else-if="lesson.status.value === 'OPENED'">
                    {{ lesson.rate < 100 ? $t("144") : $t("146") }}
                    <!-- 학습중 -->
                  </span>
                  <!-- {{lesson.status.value}} -->
                </div>
              </div>
            </div>
            <div v-if="lesson.learningMaterials.length > 0">
              <img
                src="@/images/icon/download_icon.png"
                @click.stop="downloadFileOnMobile(lesson.learningMaterials[0])"
                class="icon"
              />
              <!-- donwloadFile(lesson.learningMaterials[0]); -->
            </div>
          </div>

          <div class="d-flex flex-row" v-if="lessonsList.length > index + 1">
            <div class="mgl-16 mgr-16 w-40"></div>
            <div class="flex-grow-1">
              <hr class="divider" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/**
 * 나의 학습 상세 - 레슨 컴포넌트(my learning view - lesson component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import httpService from "@/api/httpService";
import learnApi from "@/api/learnApi.js";
import { fileMixin } from "@/mixins/file.js";
import NoData from "../../common/NoData.vue";

// Sentry
import * as Sentry from '@sentry/vue'; // breadcrumb 위해 필요
import { captureApiError } from '@/utils/sentryApiHandler';

export default {
  components: {
    "no-data": NoData,
  },
  data() {
    return {
      lessonData: null,
      lessonsList: [],
      dataLoadState: false,
      nextLessonData: null,
      nextLessonName: "",
      nextProgressionId: null,
    };
  },

  mixins: [fileMixin],

  mounted() {
    this.fetchData();
  },

  updated() {
    const ripples = [].map.call(
      document.querySelectorAll(".ripple-item"),
      function (el) {
        let ripple = new MDCRipple.attachTo(el);
        return ripple;
      }
    );
  },

  methods: {
    // 차시정보 API 호출 및 데이터 설정(get lesson list data)
    fetchData() {
      this.lessonsList = [];
      let params = this.setParams();

      //차시 정보
      this.$showLoading(this.$refs.lessonList);

      learnApi
        .learnViewCourses(params)
        .then((response) => {
          this.lessonData = response.data.data;
          // 과정의 차시 정보만 병합(merge lesson data)
          _.each(this.lessonData, (course) => {
            this.lessonsList = this.lessonsList.concat(course.lessons);
          });

          this.$hideLoading();
          this.dataLoadState = true;
        })
        .catch((err) => {
          console.log(err);
          captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
        });

      // get next lesson
      learnApi.learnLessonNext(params).then((response) => {
        this.nextLessonData = response.data.data;
        console.log('nextLessonData', this.nextLessonData);
        if (this.nextLessonData) {
          this.nextLessonName = this.nextLessonData.name;
          this.nextProgressionId = this.nextLessonData.progressionId;
          this.$emit("setNextLesson", this.nextLessonData);
        }

        this.$emit("setNextLesson", this.nextLessonData);
      }).catch((err) => {
        captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
      });
    },

    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        learnId: this.$route.params.learnId,
      };
      return params;
    },

    // learn lesson
    learnLesson(lesson) {
      if (lesson.status.value === "OPENED") {
        if (lesson.contentsType.value === "EXAM_PAPER") {
          this.$router.push({
            name: "LessonExamIntro",
            params: {
              learnId: this.$route.params.learnId,
              examineeId: lesson.examineeId,
            },
            query: this.$route.query,
          });
        } else {
          this.$router.push({
            name: "LessonView",
            params: {
              learnId: this.$route.params.learnId,
              lessonId: lesson.id,
              progressionId: lesson.progressionId,
            },
            query: this.$route.query,
          });
        }
      } else {
        this.$alert({
          //title: "순차학습 안내",
          content: this.$t("1885") + "<br>" + this.$t("1886"),
          accept: this.$t("1887"),
        }).then(() => {});
      }
    },
  },
};
</script>

<style scoped>
.material-icons.orange600 {
  color: #2d6dcc;
}
</style>